import { InputAdornment } from '@mui/material';
import React from 'react';
import { PrimaryButton, PrimaryTextField } from 'components';
import { YoutubeIcon } from 'assets/icons';
import { useNavigate, useParams } from 'react-router-dom';

interface Props {
  importHandler: (videoUrl: string) => void;
}

const YoutubeImport = ({ importHandler }: Props) => {
  const { conversationId } = useParams();
  const navigate = useNavigate();

  const [videoUrl, setVideoUrl] = React.useState<string>('');
  const handleImport = () => {
    const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    const match = videoUrl.match(regExp);
    if (match) {
      importHandler(videoUrl);
    }
  };

  return (
    <div>
      <PrimaryTextField
        sx={{ mb: 1, mt: 0 }}
        startAdornment={<InputAdornment position="start"><YoutubeIcon /></InputAdornment>}
        placeholder="https://www.youtube.com/rugby..."
        value={videoUrl}
        onChange={(e: any) => { setVideoUrl(e.target.value); }}

      />
      <PrimaryButton fullWidth onClick={handleImport}>
        Import from YouTube
      </PrimaryButton>
    </div>
  );
};

export default YoutubeImport;
